<template>
    <component
        :is="tag"
        class="ds-badge"
        :href="tag === 'a' ? href : undefined"
        :rel="tag === 'a' ? 'noopener noreferrer' : undefined"
        :target="tag === 'a' ? '_blank' : undefined"
    >
        <DsIcon
            v-if="iconLeft"
            :width="16"
            :height="16"
            :name="iconLeft"
            :is-in-storybook="isInStorybook"
            class="ds-badge__icon-left"
        />
        <span v-if="text" class="ds-badge__text" v-html="text" />
        <span v-else class="ds-badge__text">
            <slot />
        </span>
        <DsIcon
            v-if="iconRight"
            :width="16"
            :height="16"
            :name="iconRight"
            :is-in-storybook="isInStorybook"
            class="ds-badge__icon-right"
        />
    </component>
</template>

<script lang="ts" setup generic="T">
import DsIcon from "../icon/ds-icon.vue";
import { SvgBaseIcons } from "../icon/types";

// https://github.com/vuejs/core/issues/8952
type ConditionalProps =
    | {
          tag?: "button" | "span" | "div";
          href?: never;
      }
    | {
          tag?: "a";
          href: string;
      };

const { tag = "div", href } = defineProps<
    {
        /**
         * Set text
         */
        text?: string;
        /**
         * Set thin variant left icon
         */
        iconLeft?: SvgBaseIcons;
        /**
         * Set thin variant right icon
         */
        iconRight?: SvgBaseIcons;
        /**
         * Set storybook path
         */
        isInStorybook?: boolean;
    } & ConditionalProps
>();
</script>
